export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_CREATE = 'USER_CREATE';
export const USER_REQUEST_ALL = 'USER_REQUEST_ALL';
